export let crudHeadersGenerator = null;
export const setCrudHeadersGenerator = (headerGen) => {
  crudHeadersGenerator = headerGen;
};
export let crudOnUnauthenticated = null;
export const setCrudOnUnauthenticated = (onUnauthenticated) => {
  crudOnUnauthenticated = onUnauthenticated;
};
